<template>
    <div class="address">
        <div class="head">
            <h3 style="font-size: 24px;
font-weight: 500;">我的地址薄</h3>
            <p style="color: #ff904d;cursor: pointer;font-size: 16px;" @click="add">
                <i class="el-icon-circle-plus-outline"></i>
                新增
            </p>
        </div>
        <div class="item_box">
            <div v-for="(item, index) in List" :key="index" class="item">
                <div style="display: flex;justify-content: space-between;">
                    <p style="font-size: 18px;">收货地址{{ index + 1 }}</p>
                    <p style="color: #ff904d;cursor: pointer;font-size: 16px;">
                        <span @click="editDialog(item)"><i class="el-icon-edit-outline"></i>编辑</span>
                        <span @click="delDialog(item)"><i class="el-icon-delete"></i>删除</span>
                        
                    </p>
                </div>
                <div>
                    <p style="color: #6B7280;font-size: 14px;">收货人姓名</p>
                    <p style="font-size: 16px;">{{ item.name }}</p>
                    <p style="color: #6B7280;font-size: 14px;">收货地址</p>
                    <p style="font-size: 16px;">{{ item.province_name + item.city_name + item.area_name + item.address
                        }}
                    </p>
                    <p style="color: #6B7280;font-size: 14px;">联系方式</p>
                    <p style="font-size: 16px;">{{ item.mobile }}</p>
                    <p @click.stop.prevent="setDefault(item)"><el-radio v-model="item.is_default"
                            :label="1">设为默认地址</el-radio></p>

                </div>
            </div>
        </div>
        <!-- 弹框 -->
        <el-dialog :title="diaTitle" :visible.sync="dialogFormVisible" width="600px" custom-class="addressdialog"
            :destroy-on-close="true">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px"
                v-if="dialogFormVisible" v-loading.fullscreen.lock="fullscreenLoading" class="demo-ruleForm">
                <el-form-item label="收货人姓名" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入收货人姓名"></el-input>
                </el-form-item>
                <el-form-item label="所在地区" prop="arr">
                    <el-cascader style="width: 100%;" v-model="ruleForm.arr" :props="props" @change="handleChange"
                        ref="cascader">
                        <template slot-scope="{ node, data }">
                            <span @click="handleClick(data)">{{ data.label }}</span>
                        </template>
                    </el-cascader>

                </el-form-item>
                <el-form-item label="收货地址" prop="address">
                    <el-input v-model="ruleForm.address" placeholder="请输入收货地址"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="mobile">
                    <el-input oninput="value=value.replace(/\D/gi,'')" v-model="ruleForm.mobile" maxlength="11" placeholder="请输入收货人联系方式"></el-input>
                </el-form-item>
                <div class="btnbox">
                    <el-button class="btn" style="background-color: #FFFAE5;"
                        @click="resetForm('ruleForm')">取消</el-button>
                    <el-button class="btn" style="background-color: #ff904d;" type="primary"
                        @click="submitForm('ruleForm')">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>

</template>
<script>

export default {
    components: {

    },
    data() {
        return {
            dialogFormVisible: false,
            ruleForm: {},
            rules: {
                name: [{ required: true, trigger: 'blur', message: '请输入' }],
                arr: [{ required: true, trigger: 'change', message: '请选择' }],
                address: [{ required: true, trigger: 'blur', message: '请输入' }],
                mobile: [{ required: true, trigger: 'blur', message: '请输入' },{pattern:/^1[3456789]\d{9}$/,message:'请输入正确的手机号',trigger:'blur'}],

            },
            radio: 0,
            diaTitle: '编辑地址',
            options: [],
            props: {
                lazy: true,
                lazyLoad(node, resolve) {
                    const { level } = node;
                    setTimeout(() => {
                        const nodes = Array.from({ length: level + 1 })
                            .map(item => ({
                                value: ++id,
                                label: `选项${id}`,
                                leaf: level >= 2
                            }));
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }, 1000);
                }
            },
            List: [],
            fullscreenLoading: false,
            areaList: [],
            isShowCase: true,
            defaultSelectedValue: [1, 12, 123], // 默认值
        }
    },
    mounted() {
        this.getOptions()
        this.getList()
    },
    methods: {
        delDialog(item) {            
            this.$http.post('/api/addressBookDel', { id: item.id }).then((res) => {
                if (res.data.code == 200) {
                    this.$message({
                        message: res.data.msg,
                        type: 'success'
                    })

                    this.getList()
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'warning'
                    })
                }
            })
        },
        setDefault(item) {
            this.$http.post('/api/setDefaultAddress', { id: item.id }).then((res) => {
                if (res.data.code == 200) {
                    this.getList()
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'warning'
                    })
                }
            })
        },
        handleClick(data) {

        },
        handleChange(value) {

        },
        getList() {
            this.$http.get('/api/addressBookList').then((res) => {
                if (res.data.code == 200) {
                    this.List = res.data.data
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'warning'
                    })
                }
            })
        },
        getOptions() {
            let that = this
            this.props = {
                lazy: true,
                lazyLoad(node, resolve) {

                    const { level, value, label } = node;
                    if (level == 2) {
                        that.ruleForm.city_name = label
                        that.$http.get('/api/areaList?city_id=' + value).then((res) => {
                            if (res.data.code == 200) {
                                that.areaList = res.data.data
                                setTimeout(() => {
                                    const nodes = res.data.data
                                        .map(item => ({
                                            value: item.area_id,
                                            label: item.area,
                                            leaf: level >= 2
                                        }));
                                    // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                    resolve(nodes);
                                }, 100)
                            } else {
                                that.$message({
                                    message: res.data.msg,
                                    type: 'warning'
                                })
                            }
                        })

                    } else
                        if (level == 1) {
                            that.ruleForm.province_name = label
                            that.$http.get('/api/cityList?province_id=' + value).then((res) => {
                                if (res.data.code == 200) {
                                    setTimeout(() => {
                                        const nodes = res.data.data
                                            .map(item => ({
                                                value: item.city_id,
                                                label: item.city,
                                                leaf: level >= 2
                                            }));
                                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                        resolve(nodes);
                                    }, 100)
                                } else {
                                    that.$message({
                                        message: res.data.msg,
                                        type: 'warning'
                                    })
                                }
                            })

                        } else if (level == 0) {
                            that.$http.get('/api/provinceList').then((res) => {
                                if (res.data.code == 200) {
                                    setTimeout(() => {
                                        const nodes = res.data.data
                                            .map(item => ({
                                                value: item.province_id,
                                                label: item.province,
                                                leaf: level >= 2
                                            }));
                                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                        resolve(nodes);
                                    }, 100)
                                } else {
                                    that.$message({
                                        message: res.data.msg,
                                        type: 'warning'
                                    })
                                }
                            })
                        }



                }
            }
        },
        editDialog(item) {
            this.fullscreenLoading = true;
            this.dialogFormVisible = true
            this.diaTitle = '编辑地址'
            this.ruleForm = JSON.parse(JSON.stringify(item))

            this.ruleForm.arr = [item.province_id, item.city_id, item.area_id]
            setTimeout(() => {

                this.fullscreenLoading = false;
            }, 1000)
        },
        add() {
            this.dialogFormVisible = true
            this.diaTitle = '新增地址'
            this.ruleForm = {}
        },
        submitForm(formName) {
            let that = this
            that.ruleForm.area_name = ''
            that.areaList.map(element => {
                if (element.area_id == that.ruleForm.arr[2]) {
                    that.ruleForm.area_name = element.area
                }
            })
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.province_id = this.ruleForm.arr[0]
                    this.ruleForm.city_id = this.ruleForm.arr[1]
                    this.ruleForm.area_id = this.ruleForm.arr[2]
                    if (this.ruleForm.id) {
                        //编辑
                        that.$http.post('/api/addressBookEdit', that.ruleForm).then((res) => {
                            if (res.data.code == 200) {
                                that.$message.success('修改成功')
                                that.getList()

                                that.dialogFormVisible = false
                            } else {
                                that.$message({
                                    message: res.data.msg,
                                    type: 'warning'
                                })
                            }
                        })
                    } else {
                        //新增

                        that.$http.post('/api/addressBookAdd', that.ruleForm).then((res) => {
                            if (res.data.code == 200) {
                                that.$message.success('新增成功')
                                that.getList()

                                that.dialogFormVisible = false
                            } else {
                                that.$message({
                                    message: res.data.msg,
                                    type: 'warning'
                                })
                            }
                        })
                    }



                } else {
                    console.log('error submit!!');
                    return false;
                }
            });


        },
        resetForm() {
            this.ruleForm = {}
            this.dialogFormVisible = false
        },
    }
}
</script>
<style lang="less" scoped>
.address {
    padding: 24px;

    .head {
        display: flex;
        justify-content: space-between;
    }

    .item_box {
        margin-top: 12px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        .item {
            width: 452px;
            min-width: 452px;
            height: 314px;
            border: 1px solid #E6E6E6;
            border-radius: 16px;
            margin-right: 23px;
            margin-bottom: 24px;
            padding: 24px;

            p {
                line-height: 2.5;
            }
        }
    }

    /deep/.addressdialog {
        background-color: #FFFAE5;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
        border-radius: 16px;

        .btnbox {
            display: flex;
            flex-direction: row;
            justify-content: space-around;

            .btn {
                width: 48%;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/children/Address.vue